var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPending(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_Icon2 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wallet",
    transform: "translate(-422.000000, -1050.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_Icon2-Copy",
    transform: "translate(422.000000, 1050.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#FFCC00",
    cx: 10.5,
    cy: 10.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.62443719,9 C8.55319229,9 8.48082247,8.9759375 8.41670206,8.9265 L6.16686306,7.1765 C6.06262052,7.095125 6,6.958625 6,6.8125 L6,2.4375 C6,2.196 6.16798798,2 6.37497317,2 C6.58195835,2 6.74994633,2.196 6.74994633,2.4375 L6.74994633,6.5784375 L8.83292227,8.1985 C9.00540993,8.3328125 9.0519066,8.6040625 8.93678984,8.8053125 C8.86479499,8.93175 8.74555353,9 8.62443719,9",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,0.8125 C3.36375,0.8125 0.8125,3.36375 0.8125,6.5 C0.8125,9.63625 3.36375,12.1875 6.5,12.1875 C9.63625,12.1875 12.1875,9.63625 12.1875,6.5 C12.1875,3.36375 9.63625,0.8125 6.5,0.8125 M6.5,13 C2.9160625,13 0,10.0839375 0,6.5 C0,2.9160625 2.9160625,0 6.5,0 C10.0839375,0 13,2.9160625 13,6.5 C13,10.0839375 10.0839375,13 6.5,13",
    id: "Fill-3"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPending);
export default __webpack_public_path__ + "static/media/ic_pending.93f57020b065340a2cfb285b0a2d1be2.svg";
export { ForwardRef as ReactComponent };